/* Laron Wear — Shopify theme behavior */

function initHeroSlider(root) {
  if (!root) return;
  const slides = Array.from(root.querySelectorAll(".hero-slide"));
  const dots = Array.from(root.querySelectorAll(".hero-dot"));
  const prevBtn = root.querySelector(".hero-arrow.prev");
  const nextBtn = root.querySelector(".hero-arrow.next");
  let index = 0;
  let timer = null;

  function show(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle("active", n === index));
    dots.forEach((d, n) => d.classList.toggle("active", n === index));
  }

  function next() { show(index + 1); }
  function prev() { show(index - 1); }

  function restart() {
    clearInterval(timer);
    timer = setInterval(next, 5500);
  }

  if (nextBtn) nextBtn.addEventListener("click", () => { next(); restart(); });
  if (prevBtn) prevBtn.addEventListener("click", () => { prev(); restart(); });
  dots.forEach((d, n) => d.addEventListener("click", () => { show(n); restart(); }));

  root.addEventListener("mouseenter", () => clearInterval(timer));
  root.addEventListener("mouseleave", restart);

  show(0);
  restart();
}

// Product page: swap main image when a thumbnail or color swatch is clicked
function initProductGallery() {
  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImg = gallery.querySelector("[data-main-image]");
    gallery.querySelectorAll("[data-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        mainImg.src = thumb.dataset.fullImage;
        gallery.querySelectorAll("[data-thumb]").forEach((t) => t.classList.remove("active"));
        thumb.classList.add("active");
      });
    });
  });
}

// Product page: quantity stepper
function initQtySteppers() {
  document.querySelectorAll("[data-qty-stepper]").forEach((stepper) => {
    const input = stepper.querySelector("input");
    stepper.querySelector("[data-qty-minus]").addEventListener("click", () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    stepper.querySelector("[data-qty-plus]").addEventListener("click", () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initHeroSlider(document.querySelector(".hero-slider"));
  initProductGallery();
  initQtySteppers();
});
